import React, { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom';

export default function ImageSlider({ items = [{ type: '', link: '' }], isHomePageSlider = false, autoScroll = false }) {
    const carouselRef = useRef(null);
    const carouselIdRef = useRef(`carousel-${Math.random().toString(36).slice(2, 9)}`);

    const carouselItems = items.filter((item) => !!item?.link);
    const carouselId = carouselIdRef.current;

    useEffect(() => {
        if (carouselItems.length <= 1 || !carouselRef.current || !window.bootstrap?.Carousel) {
            return undefined;
        }

        const carousel = window.bootstrap.Carousel.getOrCreateInstance(carouselRef.current, {
            interval: autoScroll ? 3000 : false,
            ride: autoScroll ? 'carousel' : false,
            wrap: true,
        });

        if (autoScroll) {
            carousel.cycle();
        }

        return () => {
            carousel.dispose();
        };
    }, [carouselItems.length, autoScroll]);

    return (
        carouselItems.length > 0 &&
        <div
            id={carouselId}
            ref={carouselRef}
            className="carousel slide"
            data-bs-ride={autoScroll ? "carousel" : "false"}
            data-bs-interval={autoScroll ? "3000" : "false"}
        >
            {carouselItems.length > 1 &&
                <div className="carousel-indicators">
                    {carouselItems.map((item, index) => (
                        <button
                            key={`indicator-${index}`}
                            type="button"
                            data-bs-target={`#${carouselId}`}
                            data-bs-slide-to={`${index}`}
                            className={index === 0 ? 'active' : ''}
                            aria-current={index === 0 ? 'true' : undefined}
                            aria-label={`Slide ${index + 1}`}
                        ></button>
                    ))}
                </div>
            }
            <div className="carousel-inner">
                {carouselItems.map((item, index) => (
                    item.type === 'img' ?
                        <Link
                            key={`slide-${index}`}
                            to={item?.sliderLink ?? '#'}
                            target={item?.isExternalLink ? '_blank' : '_self'}
                            className={`carousel-item ${index === 0 ? 'active' : ''}`}
                        >
                            <img src={item?.link} className="d-block w-100" alt={item?.title || 'slider item'} style={{ marginTop: 15, marginBottom: 0 }} />
                            {isHomePageSlider &&
                                <div className="carousel-caption d-none d-md-block">
                                    {<h5>{item?.title}</h5>}
                                    {<p>{item?.subTitle}</p>}
                                </div>
                            }
                        </Link> :
                        <div key={`slide-${index}`} className={`carousel-item ${index === 0 ? 'active' : ''} `}>
                            <iframe width="100%" height="500" style={{ maxHeight: 460.5 }} src={item?.link} title="YouTube video player" frameBorder="0" allow="muted; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen={true}></iframe>
                            {isHomePageSlider &&
                                <div className="carousel-caption d-none d-md-block">
                                    {<h5>{item?.title}</h5>}
                                    {<p>{item?.subTitle}</p>}
                                </div>
                            }
                        </div>
                ))}
            </div>

        </div >
    )
}
